import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

const GhostRadioV2 = ({
  label,
  name,
  selected,
  onClick,
  value,
  type,
  small,
  labelStyles,
  hasBorder,
  ...props
}) => (
  <Wrapper
    onClick={onClick}
    hasBorder={hasBorder}
    className={selected && 'selected'}>
    {type === 'radio' ? (
      <Input
        bgColor={backgroundColors.normalLeft}
        border
        id={`opt-${value}-${name}`}
        name={name}
        checked={selected}
        onChange={onClick}
        type={type}
        small={small}
        {...props}
      />
    ) : (
      <InputCheck
        bgColor={backgroundColors.normalLeft}
        border
        id={`opt-${value}-${name}`}
        name={name}
        checked={selected}
        type={type}
        small={small}
        {...props}
      />
    )}
    <Title style={labelStyles}>{label}</Title>
  </Wrapper>
)

export default GhostRadioV2

const Wrapper = styled.div`
  display: flex;
  padding: 10px;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  cursor: pointer;

  ${({ hasBorder }) =>
    hasBorder &&
    `
    border-bottom: 1px solid #ECECEC;
  `}
`

const Title = styled.span`
  color: #3e3e3e;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`

const Input = styled.input.attrs({
  type: 'radio',
})`
  display: block;
  width: ${({ small }) => (small ? '16px' : '20px')} !important;
  height: ${({ small }) => (small ? '16px' : '20px')} !important;
  position: relative;
  z-index: 1;
  cursor: pointer;
  margin: 0;
  border: none !important;
  -webkit-appearance: auto !important;

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    border-radius: 999px;
    border: 1px solid #ececec;
    background: #f9f9f9;
    z-index: 2;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    width: ${({ small }) => (small ? '8px' : '10px')};
    height: ${({ small }) => (small ? '8px' : '10px')};
    top: ${({ small }) => (small ? '4px' : '5px')};
    left: ${({ small }) => (small ? '4px' : '5px')};
    border-radius: 999px;
    background: #fff;
    z-index: 3;
    display: none;
    box-sizing: unset;
  }

  &:checked {
    &::before {
      background: ${({ bgColor }) => bgColor};
      border: none;
    }
    &::after {
      display: block;
    }
  }
`

const InputCheck = styled.input.attrs({
  type: 'checkbox',
})`
  display: block;
  width: 20px;
  height: 20px;
  position: relative;
  z-index: 1;
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    border: 1px solid #ececec;
    background: #f9f9f9;
    z-index: 2;
  }

  &::after {
    content: '';
    position: absolute;
    display: none;
    top: 2px;
    left: 7px;
    z-index: 3;
    transform: rotate(45deg);
    height: 10px;
    width: 5px;
    border-bottom: 2px solid #fff;
    border-right: 2px solid #fff;
    box-sizing: unset;
  }

  &:checked {
    &::before {
      content: '';
      background: ${({ bgColor }) => bgColor};
      border: none;
    }
    &::after {
      display: inline-block;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/GhostRadioV2/index.js